var _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _circle21, _circle22, _circle23, _circle24, _circle25, _circle26, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFqAbackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1933,
    height: 1318,
    viewBox: "0 0 1933 1318",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 130,
    cy: 383,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 246,
    cy: 635,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 230,
    cy: 987,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 477,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 1348,
    cy: 635,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1228,
    cy: 776,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 944,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1104,
    cy: 875,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1192,
    cy: 1107,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 1296,
    cy: 1287,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 1104,
    cy: 1239,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 956,
    cy: 1315,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 724,
    cy: 1283,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 508,
    cy: 1207,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 316,
    cy: 1267,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 180,
    cy: 1191,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 116,
    cy: 839,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 355,
    cy: 286,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 549,
    cy: 344,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    cx: 837,
    cy: 344,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle21 || (_circle21 = /*#__PURE__*/React.createElement("circle", {
    cx: 1033,
    cy: 408,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle22 || (_circle22 = /*#__PURE__*/React.createElement("circle", {
    cx: 1257,
    cy: 468,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle23 || (_circle23 = /*#__PURE__*/React.createElement("circle", {
    cx: 1161,
    cy: 300,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle24 || (_circle24 = /*#__PURE__*/React.createElement("circle", {
    cx: 745,
    cy: 512,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle25 || (_circle25 = /*#__PURE__*/React.createElement("circle", {
    cx: 237,
    cy: 453,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _circle26 || (_circle26 = /*#__PURE__*/React.createElement("circle", {
    cx: 477,
    cy: 457,
    r: 3,
    fill: "white",
    fillOpacity: 0.25
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_8990_20935)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1358,
    cy: 617,
    rx: 175,
    ry: 217,
    fill: "url(#paint0_linear_8990_20935)",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_8990_20935",
    x: 783,
    y: 0,
    width: 1150,
    height: 1234,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 200,
    result: "effect1_foregroundBlur_8990_20935"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8990_20935",
    x1: 1358,
    y1: 453.729,
    x2: 1358,
    y2: 834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8290FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8290FF",
    stopOpacity: 0
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFqAbackground);
export default __webpack_public_path__ + "static/media/FQAbackground.8056c36eab045dc9b1dedce70795a3fe.svg";
export { ForwardRef as ReactComponent };